import { ActionControlSize } from "@1js/acui-common";
import {
  getDownChevronIcon,
  iconNameToIconProps,
  PropsWithDownChevronIcon,
} from "@1js/acui-icons";
import { RibbonButtonProps } from "../UISurfaces/Ribbon/Controls/RibbonButton/next";
import { renderMLRLargeMenuAnchorText } from "../UISurfaces/Ribbon/renderMLRLargeMenuAnchorTextFunction";
import {
  menuTextChevronClass,
  menuTextContainerClass,
  menuTextLine2Class,
} from "@1js/acui-button";

type SizedRibbonButtonProps = Partial<PropsWithDownChevronIcon> & {
  size?: RibbonButtonProps["size"];
  label: RibbonButtonProps["label"];
  disabled?: RibbonButtonProps["disabled"];
};
/**
 * Sets custom flyout anchor content to be rendered in place of the label.
 * Handles MLR large controls where chevron needs to be on the same line as text.
 */
export function useLargeRibbonMenuButtonLabel<
  TProps extends SizedRibbonButtonProps
>(props: TProps) {
  const { size, label, disabled } = props;

  if (size?.toLowerCase() === ActionControlSize.Large.toLowerCase()) {
    const iconProps = iconNameToIconProps(getDownChevronIcon(props));
    if (iconProps) {
      return renderMLRLargeMenuAnchorText(
        label,
        iconProps,
        disabled,
        menuTextContainerClass,
        menuTextLine2Class,
        menuTextChevronClass
      );
    }
  }

  return undefined;
}
